import { isProfileField } from './profileFieldVocabulary';

export const PROFILE_PLACEMENT_MODES = Object.freeze({
  AUTOMATIC: 'automatic',
  EXPLICIT_CAREGIVER: 'explicit_caregiver',
});

export const PROFILE_PLACEMENT_CHAPTERS = Object.freeze({
  COMMUNICATION: 'communication',
  WHAT_HELPS: 'what_helps',
  WATCH_FOR: 'watch_for',
  DAILY_LIFE: 'daily_life',
  SAFETY: 'safety',
  HEALTH_CARE: 'health_care',
  GOALS: 'goals',
});

const CHAPTER_IDS = new Set(Object.values(PROFILE_PLACEMENT_CHAPTERS));

const normalizeText = (value = '') => String(value || '').trim().toLowerCase().replace(/[\s-]+/g, '_');

export const normalizeProfilePlacementMode = (value = '') => (
  normalizeText(value) === PROFILE_PLACEMENT_MODES.EXPLICIT_CAREGIVER
    ? PROFILE_PLACEMENT_MODES.EXPLICIT_CAREGIVER
    : PROFILE_PLACEMENT_MODES.AUTOMATIC
);

export const normalizeProfilePlacementChapterId = (value = '') => {
  const chapterId = normalizeText(value);
  return CHAPTER_IDS.has(chapterId) ? chapterId : '';
};

export const isExplicitProfilePlacement = (fact = {}, chapterId = '') => (
  fact.profilePlacementMode === PROFILE_PLACEMENT_MODES.EXPLICIT_CAREGIVER
  && fact.profileChapterId === normalizeProfilePlacementChapterId(chapterId)
);

export const isExplicitlyPlacedInAnotherChapter = (fact = {}, chapterId = '') => (
  fact.profilePlacementMode === PROFILE_PLACEMENT_MODES.EXPLICIT_CAREGIVER
  && fact.profileChapterId
  && !isExplicitProfilePlacement(fact, chapterId)
);

export const isProfileFactLifecycleVisible = (fact = {}) => (
  fact.resolverEligible !== false && fact.profileVisibilityOverride !== 'hide'
);

export const buildExplicitProfilePlacementMetadata = ({
  profilePlacementMode = '',
  profileChapterId = '',
  profileField = '',
} = {}) => {
  const mode = normalizeProfilePlacementMode(profilePlacementMode);
  const chapterId = normalizeProfilePlacementChapterId(profileChapterId);
  if (mode !== PROFILE_PLACEMENT_MODES.EXPLICIT_CAREGIVER || !chapterId) return {};

  const cleanProfileField = String(profileField || '').trim();
  return {
    profilePlacementMode: mode,
    profileChapterId: chapterId,
    ...(isProfileField(cleanProfileField) ? { profileField: cleanProfileField } : {}),
  };
};
